﻿document.addEventListener('DOMContentLoaded', function () {
    const sidenav = document.getElementById('sidenav');
    const backBtn = document.querySelector('.sidenav__back-btn');

    if (!sidenav) {
        return;
    }

    // sync sidenav state from localStorage
    const expanded = localStorage.getItem('sidenavExpanded') === 'true';

    if (expanded) {
        sidenav.classList.add('sidenav--expanded');
        document.documentElement.classList.add('sidenav-expanded');
        document.documentElement.classList.remove('sidenav-collapsed');
    }
    else {
        sidenav.classList.remove('sidenav--expanded');
        document.documentElement.classList.remove('sidenav-expanded');
        document.documentElement.classList.add('sidenav-collapsed');
    }

    requestAnimationFrame(() => {
        sidenav.classList.add('sidenav--animate');
    });

    sidenav.addEventListener('click', function (e) {
        if (!sidenav.classList.contains('sidenav--expanded')) {
            sidenav.classList.add('sidenav--expanded');
            document.documentElement.classList.add('sidenav-expanded');
            document.documentElement.classList.remove('sidenav-collapsed');
            localStorage.setItem('sidenavExpanded', 'true');
        }
    });

    if (backBtn) {
        backBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            sidenav.classList.remove('sidenav--expanded');
            document.documentElement.classList.remove('sidenav-expanded');
            document.documentElement.classList.add('sidenav-collapsed');
            localStorage.setItem('sidenavExpanded', 'false');
        });
    }
    
    // set default state for nested lists in sidenav
    const nestedLists = sidenav.querySelectorAll('ul.sidenav__list');
    nestedLists.forEach(list => {
        if (!list.classList.contains('sidenav__list--expanded') && !list.classList.contains('sidenav__list--collapsed')) {
            list.classList.add('sidenav__list--expanded');
        }
    });
    
    const triggers = sidenav.querySelectorAll('.nav-accordion__wrapper');
    
    triggers.forEach(trigger => {
        const newTrigger = trigger.cloneNode(true);
        trigger.parentNode.replaceChild(newTrigger, trigger);

        newTrigger.addEventListener('click', function (e) {
            if (!sidenav.classList.contains('sidenav--expanded')) {
                return;
            }

            e.stopPropagation();
            e.preventDefault();
            
            // finds the parent accordion item
            const accordionItem = this.closest('.nav-accordion');
            if (!accordionItem) {
                return;
            }
            
            // finds the immediate child to be toggled
            const panel = accordionItem.querySelector(':scope > ul.sidenav__list');
            if (!panel) {
                return;
            }
            
            const isExpanded = panel.classList.contains('sidenav__list--expanded');
            panel.classList.toggle('sidenav__list--expanded', !isExpanded);
            panel.classList.toggle('sidenav__list--collapsed', isExpanded);
            
            // updates arrow icons based on color
            const arrowIcon = this.querySelector('.icon.up-arrow--orange, .icon.up-arrow, .icon.down-arrow--orange, .icon.down-arrow');
            if (arrowIcon) {
                if (arrowIcon.classList.contains('up-arrow--orange')) {
                    arrowIcon.classList.remove('up-arrow--orange');
                    arrowIcon.classList.add('down-arrow--orange');
                }
                else if (arrowIcon.classList.contains('down-arrow--orange')) {
                    arrowIcon.classList.remove('down-arrow--orange');
                    arrowIcon.classList.add('up-arrow--orange');
                }
                else if (arrowIcon.classList.contains('up-arrow')) {
                    arrowIcon.classList.remove('up-arrow');
                    arrowIcon.classList.add('down-arrow');
                }
                else if (arrowIcon.classList.contains('down-arrow')) {
                    arrowIcon.classList.remove('down-arrow');
                    arrowIcon.classList.add('up-arrow');
                } 
            }
        });
    });
});
